import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { naviListData } from '../data';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

export default () => {
  let pathname = '';
  if (typeof window !== `undefined`) pathname = location.pathname;
  const isNowEng = pathname.indexOf('/eng/') !== -1;
  const langauageType = isNowEng ? 'eng' : 'ja';
  const toJaLink = isNowEng ? pathname.replace('/eng/', '') : pathname;
  const toEngLink = isNowEng ? pathname : `/eng${pathname}`;
  const naviList = naviListData.filter((item) => item.type === langauageType);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Wrap>
      <Text to="/">ぴんとくるくる浄土</Text>
      <NavListWrap>
        {naviList.map((item) => (
          <NavListItem>
            <Link to={item.link}>{item.name}</Link>
          </NavListItem>
        ))}
      </NavListWrap>
      {/* <div style={{ marginLeft: '60px' }}>
        <Langauge to={toJaLink} className={pathname}>
          Ja
        </Langauge>
        <span>/</span>
        <Langauge to={toEngLink} className={pathname}>
          En
        </Langauge>
      </div> */}
      {/* <MenuButton aria-haspopup="true" onClick={handleClick}>
        <img
          src="https://iconbox.fun/wp/wp-content/uploads/bars_24.svg"
          alt=""
        />
      </MenuButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {naviList.map((item) => (
          <MenuItem onClick={handleClose}>
            <Link to={item.link}>{item.name}</Link>
          </MenuItem>
        ))}
      </Menu> */}
    </Wrap>
  );
};

const Wrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const Text = styled(Link)`
  padding-left: 20px;
  text-decoration: none;
`;

const MenuButton = styled.button`
  width: 12%;
`;

const Langauge = styled(Link)`
  padding-left: 10px;
  padding-right: 10px;
  opacity: ${(props) => (props.to === props.className ? 1.0 : 0.3)};
`;
const NavListWrap = styled.ul`
  display: flex;
  justify-content: center;
  list-style: none;
  padding: 0;
  margin: 0;
`;

const NavListItem = styled.li`
  display: inline-flex;
  align-items: center;
  margin: 0 1em;
  a {
    color: currentColor;
  }
`;
